<template>
  <div class="section-editor-toolbar">
    <div class="section-editor-toolbar-left">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            v-if="!hideEditButton"
            width="28px"
            height="28px"
            class="mr-2"
            fab
            depressed
            color="accent"
            @click="editSection"
          >
            <v-icon fill="white" style="width: 14">$edit</v-icon>
          </v-btn>
        </template>
        <span>Edit section</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            v-if="!hideDeleteButton"
            width="28px"
            height="28px"
            class="mr-2"
            fab
            depressed
            color="error"
            @click="deleteSection"
          >
            <v-icon small>mdi-trash-can-outline</v-icon>
          </v-btn>
        </template>
        <span>Delete section</span>
      </v-tooltip>
    </div>

    <div class="section-editor-toolbar-right">
      <v-tooltip bottom v-if="section.global && !hideGlobalButton">
        <template v-slot:activator="{ on }">
          <v-btn
            readonly
            v-on="on"
            width="28px"
            height="28px"
            fab
            dark
            depressed
            color="warning"
          >
            <v-icon small>mdi-earth</v-icon>
          </v-btn>
        </template>
        <span
          >This is a global section. Changes made here will affect all
          pages.</span
        >
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { deleteSection } from '@/graphql/section.gql'

export default {
  name: 'SectionEditorToolbar',
  props: {
    section: {
      type: Object,
      required: true
    },
    pageID: {
      type: String,
      required: true
    },
    hideGlobalButton: {
      type: Boolean,
      default: false
    },
    hideEditButton: {
      type: Boolean,
      default: false
    },
    hideDeleteButton: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapActions('editor', ['openEditor', 'confirmAndSaveChanges']),
    editSection() {
      this.openEditor({
        type: 'section-editor',
        size: 'sm',
        itemID: this.section.id
      })
    },
    deleteSection() {
      this.confirmAndSaveChanges({
        mutation: deleteSection,
        variables: {
          id: this.section.id
        },
        messages: {
          success: 'Section successfully deleted.',
          confirm: 'All data you have added to this section will be lost.'
        },
        refetch: true,
        close: false
      })
    }
  }
}
</script>

<style scoped>
.section-editor-toolbar-left {
  position: absolute;
  bottom: 6px;
  left: 6px;
  z-index: 10;
}
.section-editor-toolbar-right {
  position: absolute;
  bottom: 6px;
  right: 6px;
  z-index: 10;
}
</style>
